import { ReactNode } from 'react';
import { Link as RouterLink } from 'react-router-dom';

interface LinkProps {
  href: string;
  children: ReactNode;
  size?: 'sm' | 'base' | 'lg';
  isExternal?: boolean;
  className?: string;
}

export const Link: React.FC<LinkProps> = ({
  href,
  children,
  size = 'base',
  isExternal = false,
  className = '',
}) => {
  const sizeClasses = {
    sm: 'text-sm',
    base: 'text-base',
    lg: 'text-lg',
  };

  const baseClasses = `
    relative
    inline-block
    transition-colors
    duration-300
    after:content-['']
    after:absolute
    after:bottom-0
    after:left-0
    after:w-full
    after:h-[1px]
    after:bg-current
    after:origin-left
    after:scale-x-100
    after:transition-transform
    after:duration-300
    hover:after:origin-right
    hover:after:scale-x-0
  `;

  if (isExternal) {
    return (
      <a
        href={href}
        target="_blank"
        rel="noopener noreferrer"
        className={`${baseClasses} ${sizeClasses[size]} ${className}`}
      >
        {children}
      </a>
    );
  }

  return (
    <RouterLink
      to={href}
      className={`${baseClasses} ${sizeClasses[size]} ${className}`}
    >
      {children}
    </RouterLink>
  );
};
